import type { PriceListUerRowBase } from 'gql/graphql';
import { useProjectData } from 'hooks/useProjectData';
import { Checkbox } from 'uikit';

import type { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import type { ICheckedChangeItem } from './usePriceListUerForTechPartRatioColumns';
import { getPriceListUerBaseColumns } from './usePriceListUerForTechPartRatioColumns';

interface IUsePriceListUerForConstraintRatioColumnsProps {
    onRowSelectChange: (changeState: ICheckedChangeItem[]) => void;
    selectedId: number;
    onFiltersUpdated: ({ fieldName, checkedValues }: { fieldName: string; checkedValues: string[] }) => void;
}

export const usePriceListUerForConstraintRatioColumns = (props: IUsePriceListUerForConstraintRatioColumnsProps) => {
    const { onRowSelectChange, selectedId, onFiltersUpdated } = props;

    const { id: projectId } = useParams();
    const { projectData } = useProjectData(projectId);

    const filterVariables = useMemo(
        () => ({
            contractId: projectData?.contractId,
        }),
        [projectData?.contractId],
    );

    return useMemo<ColDef<PriceListUerRowBase>[]>(
        () => [
            {
                width: 55,
                resizable: false,
                cellRenderer: ({ data }: { data: PriceListUerRowBase & { type: string } }) => {
                    const { id, groupName, type } = data ?? {};
                    const isSection = type === 'section';

                    return isSection ? (
                        <Checkbox
                            checked={data?.id === selectedId}
                            onChange={({ checked }) =>
                                onRowSelectChange([{ item: { id, label: groupName, data }, isChecked: checked }])
                            }
                        />
                    ) : (
                        <Checkbox checked={data?.sectionId === selectedId} disabled />
                    );
                },
                lockPinned: true,
                pinned: 'left',
            },
            ...getPriceListUerBaseColumns(filterVariables, onFiltersUpdated),
        ],
        [filterVariables, onFiltersUpdated, onRowSelectChange, selectedId],
    );
};
